export default __webpack_public_path__ + "46d0d12f7ec7d1b5cc5aabe012cfb2a4.svg";